export const RouteGetAuthSsoMerchants = "/auth/sso/merchants";

export interface AuthSsoMerchant {
  id: number;
  name: string;
}

export interface ResponseGetAuthSsoMerchants {
  merchants: AuthSsoMerchant[];
}
